import { Dispatch, memo, SetStateAction } from 'react';

import { Modal } from '@/lib/v2/components';

import { FormSenderContent } from './FormSenderContent';
import { SenderHeader } from './SenderHeader';

interface CreateSenderModalProps {
  isOpen: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
  isStep?: boolean;
  onSenderComplete?: (complete: boolean) => void;
}

const CreateSenderModal = ({
  isOpen,
  onClose,
  isStep = false,
  onSenderComplete,
}: CreateSenderModalProps) => {
  return (
    <Modal externalClose open={isOpen} onClose={onClose}>
      <div className="flex w-full flex-col gap-4 divide-y">
        <SenderHeader />
        <FormSenderContent isStep={isStep} onClose={onClose} onSenderComplete={onSenderComplete} />
      </div>
    </Modal>
  );
};

export default memo(CreateSenderModal);
